import {Injectable, signal} from "@angular/core"
import {UnassignedJobData} from "@template-editor/helpers/template-jobs"

@Injectable()
export class TemplateJobManagerService {
    readonly $unassignedJobs = signal<UnassignedJobData[]>([])
    readonly $selectedUnassignedJob = signal<UnassignedJobData | undefined>(undefined)
}
